import { estruturaItensMap } from '../risrotEstruturaCatalog';
import RisrotEstruturaTable from './RisrotEstruturaTable';
import type { RisrotEstruturaBaseProps } from './RisrotEstruturaTable';

const ESTRUTURA = 'Crista' as const;

export default function EstruturaCrista(props: RisrotEstruturaBaseProps) {
	return (
		<RisrotEstruturaTable
			{...props}
			structureName={ESTRUTURA}
			fixedItems={estruturaItensMap[ESTRUTURA]}
		/>
	);
}
